import React from "react";
import { Box, Container, Heading, Text, SimpleGrid, VStack, Icon, Badge, Table, Thead, Tbody, Tr, Th, Td } from "@chakra-ui/react";
import { FaUniversity, FaHandshake, FaPercent, FaDollarSign } from "react-icons/fa";
import { NavbarWithCallToAction } from "../../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { SEOHead } from "../../../components/SEOHead";

const NAVY = "#141C49";
const TEAL = "#0D7F6E";
const SAND = "#C2A878";

const PropertyServicesInvestmentFinancing: React.FC = () => {
  return (
    <Box minH="100vh" bg="white">
      <SEOHead
        pagePath="/property/services/investment-financing"
        fallbackTitle="Investment Property Financing – One Property Australia"
        fallbackDescription="Specialized financing for property investments. Access competitive loan products designed specifically for property investors."
      />
      <NavbarWithCallToAction />

      <Box bg={NAVY} color="white" py={20}>
        <Container maxW="container.xl">
          <VStack spacing={6} textAlign="center">
            <Icon as={FaUniversity} boxSize={16} />
            <Heading size="3xl" fontWeight="black">Investment Property Financing</Heading>
            <Text fontSize="xl" maxW="3xl">Access competitive loan products designed specifically for property investors</Text>
          </VStack>
        </Container>
      </Box>

      <Container maxW="container.xl" py={16}>
        <VStack spacing={4} textAlign="center" mb={12}>
          <Heading size="xl">Lender Comparison</Heading>
          <Text fontSize="lg" color="gray.600">We work with Australia's top investment lenders</Text>
        </VStack>

        <Box bg="white" borderRadius="xl" border="1px" borderColor="gray.200" overflow="hidden">
          <Table variant="simple">
            <Thead bg={NAVY}>
              <Tr>
                <Th color="white">Lender</Th>
                <Th color="white">Interest Rate</Th>
                <Th color="white">LVR Max</Th>
                <Th color="white">Special Features</Th>
              </Tr>
            </Thead>
            <Tbody>
              <Tr>
                <Td fontWeight="bold">Major Bank A</Td>
                <Td>5.89%</Td>
                <Td>90%</Td>
                <Td>Offset account</Td>
              </Tr>
              <Tr bg="gray.50">
                <Td fontWeight="bold">Major Bank B</Td>
                <Td>5.79%</Td>
                <Td>85%</Td>
                <Td>Low fees</Td>
              </Tr>
              <Tr>
                <Td fontWeight="bold">Specialist Lender</Td>
                <Td>6.19%</Td>
                <Td>95%</Td>
                <Td>High LVR</Td>
              </Tr>
              <Tr bg="gray.50">
                <Td fontWeight="bold">Online Lender</Td>
                <Td>5.69%</Td>
                <Td>80%</Td>
                <Td>Fast approval</Td>
              </Tr>
            </Tbody>
          </Table>
        </Box>
      </Container>

      <Box bg="gray.50" py={16}>
        <Container maxW="container.xl">
          <VStack spacing={4} textAlign="center" mb={12}>
            <Heading size="xl">Financing Options</Heading>
          </VStack>
          <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={6}>
            <Box bg="white" p={6} borderRadius="xl" boxShadow="md" textAlign="center">
              <Icon as={FaPercent} boxSize={10} color={TEAL} mb={4} />
              <Heading size="sm" mb={2}>Variable Rate</Heading>
              <Text fontSize="sm" color="gray.600">Flexibility & offset benefits</Text>
            </Box>
            <Box bg="white" p={6} borderRadius="xl" boxShadow="md" textAlign="center">
              <Icon as={FaDollarSign} boxSize={10} color={TEAL} mb={4} />
              <Heading size="sm" mb={2}>Fixed Rate</Heading>
              <Text fontSize="sm" color="gray.600">Rate certainty for 1-5 years</Text>
            </Box>
            <Box bg="white" p={6} borderRadius="xl" boxShadow="md" textAlign="center">
              <Icon as={FaHandshake} boxSize={10} color={SAND} mb={4} />
              <Heading size="sm" mb={2}>Split Loan</Heading>
              <Text fontSize="sm" color="gray.600">Best of both worlds</Text>
            </Box>
            <Box bg="white" p={6} borderRadius="xl" boxShadow="md" textAlign="center">
              <Icon as={FaUniversity} boxSize={10} color={SAND} mb={4} />
              <Heading size="sm" mb={2}>Line of Credit</Heading>
              <Text fontSize="sm" color="gray.600">Flexible access to equity</Text>
            </Box>
          </SimpleGrid>
        </Container>
      </Box>

      <Box bg={TEAL} color="white" py={16}>
        <Container maxW="container.xl">
          <VStack spacing={6} textAlign="center">
            <Icon as={FaUniversity} boxSize={16} />
            <Heading size="xl">Get Pre-Approved Today</Heading>
            <Text fontSize="lg">Connect with our mortgage broker partners</Text>
          </VStack>
        </Container>
      </Box>

      <FooterWithFourColumns />
    </Box>
  );
};

export default PropertyServicesInvestmentFinancing;
